import Api from '@utils/api';
import { Examenes } from '@constants/urls';

export const state = {
	examenes: [],
	examen: {},
	filtro: '',
	loading: false,
	loading_action: false
};

export const getters = {
	getExamenes(state) {
		return state.examenes;
	},
	getExamen(state) {
		return state.examen;
	},
	getLoading(state) {
		return state.loading;
	},
	getLoadingAction(state) {
		return state.loading_action;
	}
};

export const mutations = {
	SET_EXAMENES(state, newValue) {
		state.examenes = newValue;
	},
	SET_EXAMEN(state, newValue) {
		state.examen = newValue;
	},
	SET_LOADING_FILES(state, newValue) {
		state.loading_action = newValue;
	},
	SET_FILTRO(state, newValue) {
		state.filtro = newValue;
	},
	SET_LOADING(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	inicializar({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Examenes.LISTAR)
			.then((response) => {
				commit('SET_EXAMENES', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerExamen({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(Examenes.OBTENER(clave))
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	establecerExamen({ commit }, examen) {
		commit('SET_EXAMEN', examen);
	},
	establecerFiltro({ commit }, { filtro }) {
		commit('SET_FILTRO', filtro);
	},
	subirArchivoCsv({ commit }, { archivos, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Examenes.CREAR, archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodos({ commit }, { onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Examenes.ELIMINAR_TODOS)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarEncabezado({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.EDITAR_ENCABEZADO(clave), params)
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => {
				commit('SET_LOADING_FILES', false);
			});
	},
	agregarAreaDeConocimiento(
		{ commit },
		{ clave, params, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.AGREGAR_AREA_DE_CONOCIMIENTO(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	agregarSeccion({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.AGREGAR_SECCION(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	agregarPregunta({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.AGREGAR_PREGUNTA(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	crearExamen({ commit }, { params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Post(Examenes.CREAR, params)
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarExamen({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Examenes.ELIMINAR(clave))
			.then((response) => {
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	quitarPregunta({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.QUITAR_PREGUNTA(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	actualizarEstatusFijaPregunta(
		{ commit },
		{ clave, params, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.ACTUALIZAR_ESTATUS_FIJA_PREGUNTA(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},

	obtenerAspirantes({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING', true);
		Api.Get(Examenes.OBTENER_ASPIRANTES(clave))
			.then((response) => {
				commit('SET_ASPIRANTES', response.data.data);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	subirArchivoAspirantesCsv(
		{ commit },
		{ clave, archivos, onComplete, onError }
	) {
		commit('SET_LOADING_FILES', true);
		Api.PostFile(Examenes.CREAR_ASPIRANTES(clave), archivos)
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarTodosAspirantes({ commit }, { clave, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Examenes.ELIMINAR_TODOS_ASPIRANTES(clave))
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	eliminarAspirantes({ commit }, { clave, ficha, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Delete(Examenes.ELIMINAR_ASPIRANTE(clave, ficha))
			.then(onComplete)
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarAreaDeConocimiento({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.EDITAR_AREA_DE_CONOCIMIENTO(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	editarSeccion({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.EDITAR_SECCION(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	quitarAreaDeConocimiento({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.QUITAR_AREA(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	},
	quitarSeccion({ commit }, { clave, params, onComplete, onError }) {
		commit('SET_LOADING_FILES', true);
		Api.Put(Examenes.QUITAR_SECCION(clave), params)
			.then((response) => {
				commit('SET_EXAMEN', response.data.data);
				onComplete(response);
			})
			.catch(onError)
			.finally(() => setTimeout(() => commit('SET_LOADING_FILES', false), 400));
	}
};
